import { SAVE_PAGE, CLEAR_PAGE } from "actions/types";
// 保存列表分页的page
export function saveListPage(val) {
  return dispatch => {
    dispatch({
      type: SAVE_PAGE,
      payload: val
    });
  };
}
// 清除列表分页的page
export function clearReduxPage() {
  return dispatch => {
    dispatch({
      type: CLEAR_PAGE,
      payload: 1
    });
  };
}
